import { useNavigate } from 'react-router-dom'

import { Layout } from '@/modules/shared/layouts/layout'

import { SalesComissionInterface } from '../interfaces/sales-comission.interface'

export function SalesComissionContainer() {
  const navigate = useNavigate()
  const handleBackPage = () => {
    navigate('/relatorios')
  }

  return (
    <Layout hasSellerFilter pageTitle="Relatório - Comissão" handleGoBack={handleBackPage}>
      <SalesComissionInterface />
    </Layout>
  )
}
